import { getLogger } from '@jitsi/logger';
import $ from 'jquery';

import JitsiMeetJS from '../../../react/features/base/lib-jitsi-meet';
import AudioOutputProblemDetector from '../../modules/AudioOutputProblemDetector';
import MOSDetector from '../../modules/MOSDetector';
import { stunConfigCredentials } from '../../modules/shareData';
import WildixXMPPEvents from '../../service/xmpp/WildixXMPPEvents';

import ChatRoom from './ChatRoom';
import JitsiConference from './JitsiConference';
import Xmpp from './Xmpp';
import QualityController from './modules/qualitycontrol/QualityController';
import SpeakerStatsCollector from './modules/statistics/SpeakerStatsCollector';

const logger = getLogger('JitsiConnection');
const origInitJitsiConference = JitsiMeetJS.JitsiConnection.prototype.initJitsiConference;

JitsiMeetJS.JitsiConnection.prototype.initJitsiConference = function(name, options) {
    const jitsiConference = origInitJitsiConference.apply(this, arguments);

    QualityController.applyOverride(jitsiConference.qualityController);
    JitsiConference.applyOverride(jitsiConference);
    const mosDetector = new MOSDetector(jitsiConference);
    const audioDetector = new AudioOutputProblemDetector(jitsiConference);

    SpeakerStatsCollector.applyOverride(jitsiConference.speakerStatsCollector, jitsiConference);

    ChatRoom.applyOverride(jitsiConference.room, jitsiConference);

    jitsiConference.room.addListener(WildixXMPPEvents.MUC_MEMBER_JOINED,
        jitsiConference.onMemberJoined.bind(jitsiConference));

    return jitsiConference;
};

JitsiMeetJS.JitsiConnection.prototype.connect = function(options = {}) {

    Xmpp.applyOverride(this.xmpp);

    // if we get redirected, we set disableFocus to skip sending the conference request twice
    if (this.xmpp.moderator.targetUrl && !this.options.disableFocus && options.name) {
        this.xmpp.moderator.sendConferenceRequest(this.xmpp.getRoomJid(options.name))
            .then(() => {
                // Orig
                this.xmpp.connect(options.id, options.password);
            })
            .catch(e => logger.trace('sendConferenceRequest rejected', e));
    } else {
        // Orig
        this.xmpp.connect(options.id, options.password);
    }

    initCustomEvents.call(this);
};

function initCustomEvents() {
    this.xmpp?.connection?._stropheConn?._addSysHandler(iq => {
        const $iqStun = $(iq).find('>services>service[password]');

        if (!$iqStun.length) {
            return;
        }
        const { host: defaultHost, port: defaultPort, username, password } = stunConfigCredentials;

        const host = $iqStun.attr('host') ?? defaultHost;
        const port = $iqStun.attr('port') ?? defaultPort;

        stunConfigCredentials.host = host;
        stunConfigCredentials.port = port;
        stunConfigCredentials.urls = `turn:${host}:${port}`;
        stunConfigCredentials.username = $iqStun.attr('username') ?? username;
        stunConfigCredentials.password = $iqStun.attr('password') ?? password;
    }, null, 'message', null, null);
}

export default JitsiMeetJS.JitsiConnection;
